import { useRoutes } from 'react-router-dom';
import { authRoute } from './sections/auth';
import { dashboardRoute } from './sections/dashboard';
import { compactRoute, fallbackNotFoundRoute, homeRoute } from './sections/main';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([authRoute, dashboardRoute, compactRoute, homeRoute, fallbackNotFoundRoute]);
}
